import React, { useState } from 'react';
import { Map, NavigationControl } from 'react-map-gl/mapbox';
import { MAPBOX_TOKEN, MAPBOX_STYLE } from '../../config';

const SimulationMap = ({ onMapLoad }) => {
  const [style, setStyle] = useState(MAPBOX_STYLE);

  const STREET_STYLE = 'mapbox://styles/mapbox/streets-v12';
  const HYBRID_STYLE = 'mapbox://styles/mapbox/satellite-streets-v12';
  const DARK_STYLE = 'mapbox://styles/mapbox/dark-v11';

  return (
    <>
      <div style={{ position: 'absolute', zIndex: 2, top: 10, right: 50 }}>
        <select value={style} onChange={e => setStyle(e.target.value)}>
          <option value={HYBRID_STYLE}>Satélite</option>
          <option value={STREET_STYLE}>Callejero</option>
          <option value={DARK_STYLE}>Oscuro</option>
        </select>
      </div>
      <Map
        initialViewState={{
            longitude: -0.50267,
            latitude: 39.53351,
            zoom: 14,
        }}
        style={{ width: '100%', height: '100%' }}
        mapStyle={style}
        mapboxAccessToken={MAPBOX_TOKEN}
        reuseMaps={false}
        onLoad={(event) => {
            const mapInstance = event.target; // Este es el mapa
            onMapLoad(mapInstance);
        }}
        >
        <NavigationControl position="top-right" />
        </Map>

    </>
  );
};

export default SimulationMap;
